import manulVRL from "./ManualVRTraining.pdf";
export const pdf = {
	manulVRL,
};
